export enum EGeneralErrorPage {
  Default = '',
  Transactions = 'transaction-list',
}
